import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { startOfMonth, subMonths } from 'date-fns';
import moment from 'moment';

import { stateDate } from '../../../../utils/formatDate';

const initialState: any = {
  signals: null,
  signalsCount: null,
  filters: {
    contracts: [],
    products: [],
  },
  limit: JSON.parse(localStorage.getItem('pageLimit') as string) || 10,
  offset: 0,
  signalsInputValues: {
    fromDate: stateDate(startOfMonth(subMonths(new Date(), 1))),
    toDate: stateDate(new Date()),
    productCode: [],
    product: '',
    employee: [],
    contract: [],
    address: '',
  },
  formattedDateFrom: moment(
    stateDate(startOfMonth(subMonths(new Date(), 1))),
  ).format('DD/MM/YYYY'),
  formattedDateTo: moment(stateDate(new Date())).format('DD/MM/YYYY'),
  status: null,
};

export const signalsSlice = createSlice({
  name: 'signals',
  initialState,
  reducers: {
    reducerGetSignals: (state: Draft<any>, action: PayloadAction<any>) => {
      state.signals = action.payload.data.data ?? [];
      state.signalsCount = action.payload.data.count;
      state.limit = action.payload.limit;
      state.offset = action.payload.offset;
    },
    reducerGetFiltersSignals: (
      state: Draft<any>,
      action: PayloadAction<any>,
    ) => {
      state.filters.contracts = action.payload.data.contract.map(
        (contract: { id: number; name: string }) => ({
          value: contract.id,
          label: contract.name,
        }),
      );
      state.filters.productCode =
        action.payload.data.productCode?.length > 0
          ? action.payload.data.productCode.map((product: number) => ({
              value: product,
              label: product.toString(),
            }))
          : [];
      state.filters.merches =
        action.payload.data.merch?.length > 0
          ? action.payload.data.merch.map(
              (merch: { id: number; name: string }) => ({
                value: merch.id,
                label: merch.name,
              }),
            )
          : [];
    },
    reducerSignalsInputValues: (
      state: Draft<any>,
      action: PayloadAction<any>,
    ) => {
      state.signalsInputValues = {
        ...state.signalsInputValues,
        ...action.payload,
      };
      if (action.payload.fromDate) {
      state.formattedDateFrom = moment(action.payload.fromDate).format(
        'DD/MM/YYYY',
      ); }
      if (action.payload.toDate) {
      state.formattedDateTo = moment(action.payload.toDate).format(
        'DD/MM/YYYY',
      );
      }
    },
    reducerSignalsStatus: (state: Draft<any>, action: PayloadAction<any>) => {
      state.status = action.payload;
    },
  },
});

export const {
  reducerGetFiltersSignals,
  reducerGetSignals,
  reducerSignalsInputValues,
  reducerSignalsStatus,
} = signalsSlice.actions;

export default signalsSlice.reducer;
